// who-we-are page bundle -> dist/js/pages/who-we-are.min.js
//
// Plain-ES port of the v3 who-we-are interactions (originally a React/DCLogic
// component: people-equation/dc/who-we-are.logic.js on feat/v3-design-pages).
// No framework: nodes are re-selected via data-* hooks. Behaviours ported:
// section parallax, Leadership/Board/Advisors tab toggle, people card hover, the profile
// drawer (the shared nav interactions — scroll auto-hide, dropdown panels,
// mobile menu, and the newsletter form's submit — now live in chrome.js and
// are loaded on every page)
// (open/close, 580ms settle, Escape + veil close, focus management, body lock),
// the podcast rail (drag + prev/next + snap), and the hero orbit hover glow.

(function () {
  "use strict";

  var root = document.querySelector(".pe-wwa");
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  // --- nodes --------------------------------------------------------------
  var peopleSec = $("[data-people]");
  var pplBody = $("[data-ppl-body]");
  var pplHead = $("[data-ppl-head]");
  var podSec = $("[data-pod]");
  var podBody = $("[data-pod-body]");
  var rail = $("[data-rail]");
  var track = $("[data-track]");
  var railPrev = $("[data-rail-prev]");
  var railNext = $("[data-rail-next]");
  var nlSec = $("[data-nl]");
  var nlBody = $("[data-nl-body]");
  var pplTabs = $$("[data-ppl-tab]");
  var drawer = $("[data-drawer]");
  var veil = $("[data-veil]");
  var drX = $("[data-dr-x]");
  var drKind = $("[data-dr-kind]");
  var drScroll = $("[data-dr-scroll]");
  var drImg = $("[data-dr-img]");
  var drName = $("[data-dr-name]");
  var drRole = $("[data-dr-role]");
  var drLi = $("[data-dr-li]");
  var drBio = $("[data-dr-bio]");
  var heroField = $("[data-field]");

  // People dataset (drawer source), keyed by slug.
  var data = {};
  try {
    var raw = $("#pe-wwa-people");
    if (raw) data = JSON.parse(raw.textContent || "{}");
  } catch (e) { data = {}; }

  var state = { tab: pplTabs.length ? pplTabs[0].dataset.pplTab : null, dr: null };
  var lastFocus = null, animating = false, settleT = null, railX = 0;

  // --- section parallax on scroll (nav auto-hide lives in chrome.js) -------
  function onScroll() {
    parallax();
  }

  // --- section parallax ---------------------------------------------------
  function parallax() {
    var vh = window.innerHeight || 800;
    if (peopleSec) {
      var top = peopleSec.getBoundingClientRect().top;
      var p = Math.max(0, Math.min(1, (vh - top) / (vh * 0.9)));
      if (pplHead) pplHead.style.transform = "translateY(" + ((1 - p) * 26).toFixed(1) + "px)";
      if (pplBody) pplBody.style.transform = "translateY(" + ((1 - p) * 12).toFixed(1) + "px)";
    }
    if (podSec && podBody) {
      var pp = Math.max(0, Math.min(1, (vh - podSec.getBoundingClientRect().top) / (vh * 0.9)));
      podBody.style.transform = "translateY(" + ((1 - pp) * 20).toFixed(1) + "px)";
    }
    if (nlSec && nlBody) {
      var np = Math.max(0, Math.min(1, (vh - nlSec.getBoundingClientRect().top) / (vh * 0.9)));
      nlBody.style.transform = "translateY(" + ((1 - np) * 18).toFixed(1) + "px)";
    }
  }

  // --- tabs: Leadership / Board / Advisors --------------------------------
  // Each [data-ppl-tab="<key>"] shows its [data-ppl-panel="<key>"]; the
  // template only renders tabs that have people in them.
  function syncTabs() {
    pplTabs.forEach(function (el) {
      var on = el.dataset.pplTab === state.tab;
      el.style.color = on ? "#081B1C" : "rgba(8,27,28,.46)";
      el.setAttribute("aria-selected", on ? "true" : "false");
      var rule = el.querySelector("[data-rule]");
      if (rule) rule.style.transform = on ? "none" : "scaleX(0)";
    });
  }
  function setTab(key) {
    state.tab = key;
    $$("[data-ppl-panel]").forEach(function (panel) {
      panel.style.display = panel.dataset.pplPanel === key ? "" : "none";
    });
    syncTabs();
    syncHover();
  }
  pplTabs.forEach(function (el) {
    el.addEventListener("click", function () { setTab(el.dataset.pplTab); });
  });

  // --- people card hover --------------------------------------------------
  var hoverKey = null;
  function hover(card, on) {
    var q = function (k) { return card.querySelector("[data-" + k + "]"); };
    card.style.background = on ? "#F2673A" : "#FFFFFF";
    var bar = q("bar"); if (bar) bar.style.transform = on ? "none" : "scaleX(0)";
    var shot = q("shot"); if (shot) shot.style.transform = on ? "scale(1.035)" : "none";
    var tag = q("tag"); if (tag) tag.style.color = on ? "rgba(20,24,26,.78)" : "#F2673A";
    var role = q("role"); if (role) role.style.color = on ? "rgba(20,24,26,.74)" : "rgba(8,27,28,.54)";
    var more = q("more"); if (more) more.style.color = on ? "#14181A" : "rgba(8,27,28,.52)";
    var plus = q("plus"); if (plus) plus.style.color = on ? "#14181A" : "#F2673A";
  }
  function syncHover() {
    if (!peopleSec) return;
    $$("[data-p]", peopleSec).forEach(function (card) {
      hover(card, card.dataset.p === hoverKey);
    });
  }
  $$("[data-p]", root).forEach(function (card) {
    card.addEventListener("mouseenter", function () { hoverKey = card.dataset.p; hover(card, true); });
    card.addEventListener("mouseleave", function () { if (hoverKey === card.dataset.p) hoverKey = null; hover(card, false); });
    card.addEventListener("focus", function () { hoverKey = card.dataset.p; hover(card, true); });
    card.addEventListener("blur", function () { if (hoverKey === card.dataset.p) hoverKey = null; hover(card, false); });
    card.addEventListener("click", function () { openProfile(card.dataset.p, card); });
    card.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openProfile(card.dataset.p, card); }
    });
  });

  // --- profile drawer -----------------------------------------------------
  function applyDrawer(animate) {
    if (!drawer || !veil) return;
    var open = !!state.dr;
    drawer.style.transition = animate ? "transform .52s cubic-bezier(.4,0,.2,1)" : "none";
    veil.style.transition = animate ? "opacity .4s ease" : "none";
    drawer.style.transform = open ? "none" : "translateX(101%)";
    drawer.style.pointerEvents = open ? "auto" : "none";
    veil.style.opacity = open ? "1" : "0";
    veil.style.pointerEvents = open ? "auto" : "none";
    if (open) drawer.removeAttribute("inert"); else drawer.setAttribute("inert", "");
  }
  function initials(name) {
    var w = String(name || "").trim().split(/\s+/).filter(Boolean);
    if (!w.length) return "";
    return (w[0].charAt(0) + (w.length > 1 ? w[w.length - 1].charAt(0) : "")).toUpperCase();
  }
  function fillDrawer(p) {
    if (drKind) drKind.textContent = p && p.kind ? p.kind : "Profile";
    if (drName) drName.textContent = p ? (p.name || "") : "";
    if (drRole) drRole.textContent = p ? (p.role || "") : "";
    if (drLi) drLi.href = p && p.li ? p.li : "#";
    if (drImg) {
      drImg.style.backgroundImage = p && p.img ? 'url("' + p.img + '")' : "none";
      // No headshot yet: show initials, as the card does.
      drImg.textContent = p && !p.img ? initials(p.name) : "";
    }
    if (drBio) drBio.innerHTML = p && p.bio ? p.bio : "";
  }
  function settle() {
    window.clearTimeout(settleT);
    settleT = window.setTimeout(function () { animating = false; applyDrawer(false); }, 580);
  }
  function openProfile(key, trigger) {
    if (!data[key]) return;
    lastFocus = trigger || null;
    animating = true;
    state.dr = key;
    fillDrawer(data[key]);
    applyDrawer(true);
    document.body.style.overflow = "hidden";
    if (drScroll) drScroll.scrollTop = 0;
    if (drX) drX.focus();
    settle();
  }
  function closeProfile() {
    if (!state.dr) return;
    animating = true;
    state.dr = null;
    applyDrawer(true);
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
    settle();
  }
  if (drX) drX.addEventListener("click", closeProfile);
  if (veil) veil.addEventListener("click", closeProfile);
  window.addEventListener("keydown", function (e) { if (e.key === "Escape" && state.dr) closeProfile(); });

  // --- podcast rail: drag + arrows + snap ---------------------------------
  function railMetrics() {
    if (!rail || !track) return null;
    var card = track.firstElementChild;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
    var step = card ? card.getBoundingClientRect().width + gap : 320;
    var min = -Math.max(0, track.scrollWidth - (rail.clientWidth - parseFloat(getComputedStyle(rail).paddingLeft) - parseFloat(getComputedStyle(rail).paddingRight)));
    return { step: step, min: min };
  }
  function railSet(x, animate) {
    var m = railMetrics();
    if (!m) return;
    railX = Math.max(m.min, Math.min(0, x));
    track.style.transition = animate ? "transform .55s cubic-bezier(.22,.61,.36,1)" : "none";
    track.style.transform = "translateX(" + railX + "px)";
    [[railPrev, railX < -1], [railNext, railX > m.min + 1]].forEach(function (pair) {
      var el = pair[0], on = pair[1];
      if (!el) return;
      el.style.opacity = on ? "1" : ".32";
      el.style.cursor = on ? "pointer" : "default";
      el.disabled = !on;
    });
  }
  function railStep(dir) {
    var m = railMetrics();
    if (!m) return;
    railSet((railX || 0) - dir * m.step, true);
  }

  // --- podcast rail auto-advance ------------------------------------------
  // Plain carousel: the rail steps forward on a steady timer only — it is NOT
  // coupled to page-scroll position (the old wheel-hijack that moved the rail
  // horizontally on scroll was removed, per QA). It loops back to the start
  // after the last card, pauses on hover, and pauses while the user drags or
  // taps an arrow (restarting once they let go).
  var AUTO_MS = 4500;
  var autoT = null;
  function railAutoNext() {
    var m = railMetrics();
    if (!m || m.min >= 0) return; // rail fits on screen — nothing to advance
    if ((railX || 0) <= m.min + 1) {
      railSet(0, true); // reached the end — loop back to the first card
    } else {
      railStep(1);
    }
  }
  function startAuto() {
    if (!rail) return;
    stopAuto();
    autoT = window.setInterval(railAutoNext, AUTO_MS);
  }
  function stopAuto() {
    if (autoT) { window.clearInterval(autoT); autoT = null; }
  }

  if (railPrev) railPrev.addEventListener("click", function () { railStep(-1); startAuto(); });
  if (railNext) railNext.addEventListener("click", function () { railStep(1); startAuto(); });
  if (rail) {
    // Pause the timer while the pointer is over the rail (hover), resume on leave.
    rail.addEventListener("mouseenter", stopAuto);
    rail.addEventListener("mouseleave", startAuto);

    rail.addEventListener("pointerdown", function (e) {
      if (e.target.closest("a, button")) return;
      // Measure ONCE per drag (step + travel limit); reusing these avoids the
      // per-move getComputedStyle/getBoundingClientRect reflow that made the
      // touch swipe janky.
      var m = railMetrics();
      if (!m) return;
      stopAuto();
      var startX = e.clientX, startAt = railX || 0, moved = false, raf = 0, pending = startAt;
      rail.style.cursor = "grabbing";
      track.style.transition = "none";
      // Capture the pointer so moves keep flowing to the rail even if the finger
      // strays off it, and the browser hands us the whole horizontal gesture.
      try { rail.setPointerCapture(e.pointerId); } catch (err) {}
      var paint = function () {
        raf = 0;
        railX = Math.max(m.min, Math.min(0, pending));
        track.style.transform = "translateX(" + railX + "px)";
      };
      var move = function (ev) {
        var dx = ev.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        if (!moved) return;
        pending = startAt + dx;
        // One transform write per frame — not one per pointermove event.
        if (!raf) raf = window.requestAnimationFrame(paint);
      };
      var up = function (ev) {
        rail.removeEventListener("pointermove", move);
        rail.removeEventListener("pointerup", up);
        rail.removeEventListener("pointercancel", up);
        if (raf) { window.cancelAnimationFrame(raf); paint(); }
        try { rail.releasePointerCapture(ev.pointerId); } catch (err) {}
        rail.style.cursor = "grab";
        if (moved) railSet(Math.round((railX || 0) / m.step) * m.step, true);
        startAuto();
      };
      rail.addEventListener("pointermove", move);
      rail.addEventListener("pointerup", up);
      rail.addEventListener("pointercancel", up);
    });
  }

  // --- hero orbit hover glow ----------------------------------------------
  // QA round 2 killed the per-circle directional beams (they read as colour
  // smudges). The highlight now lives only in the interstitial region: the
  // orbit wrappers are pointer-events:none, so hovering anywhere between the
  // circles hits [data-orbit-field], which carries a teal wash in CSS
  // (:hover) while the gradient disc below gets a saturation lift here.
  // Hovering a circle itself only triggers its own .scp3 border/shadow.
  function field(on) {
    if (heroField) {
      heroField.style.filter = on ? "blur(1px) saturate(1.45) brightness(1.1)" : "";
    }
  }
  var orbitField = $("[data-orbit-field]");
  if (orbitField) {
    orbitField.addEventListener("mouseenter", function () { field(true); });
    orbitField.addEventListener("mouseleave", function () { field(false); });
  }

  // Newsletter form submit is wired sitewide by chrome.js (R3 follow-up done).

  // --- wire up + initial paint --------------------------------------------
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", function () { railSet(railX || 0, false); parallax(); });
  syncTabs();
  parallax();
  railSet(0, false);
  startAuto();
})();
